import Tab from "bootstrap/js/src/tab";
import "sticky-kit/dist/sticky-kit";

let desktopMinWidthScreen = window.matchMedia("(min-width: 992px)");
let $stickyElementInit = $(".vertical-tabs .tab-pane .image-wrap");

function initTabs() {
  document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tabTriggerEl) => {
    new Tab(tabTriggerEl);
  });

  document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tab) => {
    tab.addEventListener("show.bs.tab", function (event) {
      if (desktopMinWidthScreen.matches) {
        setTimeout(function () {
          $(window).trigger("resize");
        }, 300);
      }
    });
  });
}

function initSticky() {
  if (desktopMinWidthScreen.matches) {
    $stickyElementInit.stick_in_parent({
      offset_top: 92,
      // inner_scrolling: true,
    });
    36;
  } else {
    $stickyElementInit.trigger("sticky_kit:detach");
  }
}

$(function () {
  initSticky();
  initTabs();

  $(window).on("resize", function () {
    initSticky();
  });
});
